import { Event } from '../Event'
import { Identity } from '../../constants'

export interface TopListExpertProfileClickedEventProperties {
  top_list_id: string
  expert_note_id: string
  expert_id: string
  position: number
}

export class TopListExpertProfileClickedEvent extends Event<
  TopListExpertProfileClickedEventProperties
> {
  static displayName = 'Top List Expert Profile Clicked'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
